import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

var firebaseConfig = {
    apiKey: "AIzaSyBUB6_anpZaWJj1mYwkyrRZI9xl6iXPWcg",
    authDomain: "arrow-nightly-jobs.firebaseapp.com",
    databaseURL: "https://arrow-nightly-jobs-default-rtdb.firebaseio.com",
    projectId: "arrow-nightly-jobs",
    storageBucket: "arrow-nightly-jobs.appspot.com",
    messagingSenderId: "18250732426",
    appId: "1:18250732426:web:a0ceadd9b7358f23d86e73",
    measurementId: "G-750ZYDP34D"
};

const app = initializeApp(firebaseConfig);

const db = getDatabase(app);

export {db}
